import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import type { SupabaseCustomEmail } from "../../../channels/email/server/supabase-custom-email-service";
import type { PermissionsFormType } from "../../types";
import type { FC } from "react";

export const EmailFromDenyListSelect: FC<{
  custom_emails: SupabaseCustomEmail[];
}> = ({ custom_emails }) => {
  const allowedAddresses = custom_emails.map((s) => ({ title: s.address, id: s.id }));

  const { control } = useFormContext<PermissionsFormType>();

  return (
    <Controller
      name="email_from_deny_list"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          multiple={true}
          value={allowedAddresses.filter((s) => field.value?.includes(s.id))}
          options={[{ title: "Select All", id: "All" }].concat(allowedAddresses)}
          renderOption={(renderProps, option) => (
            <Box component="li" {...renderProps} key={option.id}>
              {option.title}
            </Box>
          )}
          renderValue={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option.id} label={option.title} />
            ))
          }
          renderInput={(params) => (
            <TextField
              label="Restricted Senders"
              {...params}
              sx={{ mt: 2 }}
              helperText={error?.message}
              error={Boolean(error)}
              slotProps={{
                input: {
                  ...params.InputProps,
                  "data-testid": "email_from-denylist-select",
                },
              }}
            />
          )}
          getOptionLabel={(option) => option.title}
          onChange={(_, v) => {
            const value = v.map((s) => s.id);
            field.onChange(value.includes("All") ? allowedAddresses.map((p) => p.id) : value);
          }}
        />
      )}
    />
  );
};
